import { PriceTableReference } from '@models/PriceTableReference';
import { Table, Typography } from 'antd';
import TableFilters from '../../../../components/TableFilters';
import { SearchOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface TabReferenceProps {
  priceTableReferences: PriceTableReference[];
}

const TabReference: React.FC<TabReferenceProps> = ({ priceTableReferences }) => {
  const columns = [
    {
      title: 'ID Ref.',
      dataIndex: 'referenceId',
      width: '60px',
      align: 'center' as 'center',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pelo ID Ref.'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.referenceId ? record.referenceId.toString().toLowerCase().includes(value.toLowerCase()) : false;
      },
      sorter: (referenceA: any, referenceB: any) => referenceA.referenceId - referenceB.referenceId,
    },
    {
      title: 'Código Ref.',
      align: 'center' as 'center',
      width: '200px',
      render: (reference: any) => <Text>{reference?.priceTable?.referenceCode}</Text>,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pelo Código Ref.'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.priceTable?.referenceCode
          ? record.priceTable.referenceCode.toString().toLowerCase().includes(value.toLowerCase())
          : false;
      },
      sorter: (referenceA: any, referenceB: any) =>
        referenceA.priceTable.referenceCode.trim().localeCompare(referenceB.priceTable.referenceCode.trim()),
    },
    {
      title: 'Escala',
      width: '80px',
      dataIndex: 'scaleCode',
      align: 'right' as 'right',
      sorter: (referenceA: any, referenceB: any) => referenceA.scaleCode - referenceB.scaleCode,
    },
    {
      title: 'Valor',
      dataIndex: 'originalPrice',
      align: 'right' as 'right',
      render: (value: any) => (value ? <Text>{value.toFixed(2)}</Text> : <Text>0,00</Text>),
      sorter: (referenceA: any, referenceB: any) => referenceA.originalPrice - referenceB.originalPrice,
    },
    {
      title: 'Variação (%)',
      dataIndex: 'variationPercentage',
      align: 'right' as 'right',
      render: (value: any) => (value ? <Text>{value}</Text> : <Text>0</Text>),
      sorter: (referenceA: any, referenceB: any) => referenceA.variationPercentage - referenceB.variationPercentage,
    },
    {
      title: 'Variação (Valor)',
      dataIndex: 'variationValue',
      align: 'right' as 'right',
      render: (value: any) => (value ? <Text>{value.toFixed(2)}</Text> : <Text>0,00</Text>),
      sorter: (referenceA: any, referenceB: any) => referenceA.variationValue - referenceB.variationValue,
    },
  ];

  return (
    <Table
      scroll={{ x: 800 }}
      columns={columns}
      dataSource={priceTableReferences}
      pagination={{ defaultPageSize: 4, hideOnSinglePage: true, showSizeChanger: true }}
    />
  );
};

export default TabReference;
